import { FC } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import styled from 'styled-components'
import { TPreReservationFormValues } from '@app.feature/exam/gsat2024-2/constants/form'
import useGetPredictionSelectOptions from '@app.feature/exam/gsat2024-2/hooks/useGetExamTestSelectOptions'
import PredictionInputSelect from '../input/PredictionInputSelect.desktop'
import PredictionFormLabel from '../label/PredictionFormLabel.desktop'

interface IFProps {
  companyId: string
  termId: string
}

const FormItemJob: FC<IFProps> = ({ companyId, termId }) => {
  const { jobs } = useGetPredictionSelectOptions({ companyId, termId })
  const jobId = useWatch<TPreReservationFormValues, 'jobId'>({
    name: 'jobId',
  })

  const {
    setValue,
    formState: { errors },
  } = useFormContext<TPreReservationFormValues>()

  const handleOnChangeDepartment = (value: string) => {
    setValue('jobId', value, { shouldValidate: true, shouldDirty: true })
  }

  const defaultOption = jobs?.find((job) => job?.value === jobId)

  return (
    <StyledWrapper>
      <PredictionFormLabel label="직무" />
      <PredictionInputSelect
        placeholder="직무 선택"
        isErrors={!!errors.jobId?.message}
        defaultSelectOption={defaultOption}
        options={jobs}
        onChangeSelect={handleOnChangeDepartment}
      />
    </StyledWrapper>
  )
}

export default FormItemJob

const StyledWrapper = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;

  > p {
    width: 52px;
  }

  > div {
    width: 200px;
  }
`
